const Access_ControlConstants = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  SESSION_EXPIRED: "SESSION_EXPIRED",

  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE: "CHANGE_PASSWORD_FAILURE",

  FORGET_PASSWORD_SUCCESS: "FORGET_PASSWORD_SUCCESS",
  FORGET_PASSWORD_FAILURE: "FORGET_PASSWORD_FAILURE",

  GET_EQI_LIST_TOKEN_SUCCESS: "GET_EQI_LIST_TOKEN_SUCCESS",
  GET_EQI_LIST_TOKEN_FAILURE: "GET_EQI_LIST_TOKEN_FAILURE",

  ADD_ANLAGE_CHILD_SUCCESS: "ADD_ANLAGE_CHILD_SUCCESS",
  ADD_ANLAGE_CHILD_FAILURE: "ADD_ANLAGE_CHILD_FAILURE",

  GET_ANLAGE_CHILDREN_SUCCESS: "GET_ANLAGE_CHILDREN_SUCCESS",
  GET_ANLAGE_CHILDREN_FAILURE: "GET_ANLAGE_CHILDREN_FAILURE",

  DELETE_ANLAGE_CHILD_SUCCESS: "DELETE_ANLAGE_CHILD_SUCCESS",
  DELETE_ANLAGE_CHILD_FAILURE: "DELETE_ANLAGE_CHILD_FAILURE",

  GET_ANLAGE_ATTRIBUTE_BULK_SUCCESS: "GET_ANLAGE_ATTRIBUTE_BULK_SUCCESS",
  GET_ANLAGE_ATTRIBUTE_BULK_FAILURE: "GET_ANLAGE_ATTRIBUTE_BULK_FAILURE",

  SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_SUCCESS:
    "SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_SUCCESS",
  SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_FAILURE:
    "SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_FAILURE",
  BULK_DELETE_ANLAGE_ATTRIBUTE_SUCCESS: "BULK_DELETE_ANLAGE_ATTRIBUTE_SUCCESS",
  BULK_DELETE_ANLAGE_ATTRIBUTE_FAILURE: "BULK_DELETE_ANLAGE_ATTRIBUTE_FAILURE",

  GET_ANLAGE_LAST_INSPECTION_SUCCESS: "GET_ANLAGE_LAST_INSPECTION_SUCCESS",
  GET_ANLAGE_LAST_INSPECTION_FAILURE: "GET_ANLAGE_LAST_INSPECTION_FAILURE",
  LOGIN_PUBLIC_ACCESS_SUCCESS: "LOGIN_PUBLIC_ACCESS_SUCCESS",
  LOGIN_PUBLIC_ACCESS_FAILURE: "LOGIN_PUBLIC_ACCESS_FAILURE",

  GET_LOCALIZATION_MESSAGE_SUCCESS: "GET_LOCALIZATION_MESSAGE_SUCCESS",
  GET_LOCALIZATION_MESSAGE_FAILURE: "GET_LOCALIZATION_MESSAGE_FAILURE",

  BULK_UPDATE_ANLAGE_STATUS_SUCCESS: "BULK_UPDATE_ANLAGE_STATUS_SUCCESS",
  BULK_UPDATE_ANLAGE_STATUS_FAILURE: "BULK_UPDATE_ANLAGE_STATUS_FAILURE",

  PASSWORD_VALIDATION_SUCCESS: "PASSWORD_VALIDATION_SUCCESS",
  PASSWORD_VALIDATION_FAILURE: "PASSWORD_VALIDATION_FAILURE",
};
export default Access_ControlConstants;
